import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { ToastComponent } from '../toast/toast.component';
import { ToastMessage, ToastService } from '../../services/toast.service';
import { CommonModule } from '@angular/common';
import { ToastPosition } from '../../models/types/toast.enum';

@Component({
  selector: 'lib-toast-container',
  imports: [ToastComponent, CommonModule],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
})
export class ToastContainerComponent implements OnInit {
  @Input() position: ToastPosition = ToastPosition.BottomRight;

  toasts: ToastMessage[] = [];

  constructor(
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.toastService.toastState$.subscribe((toast) => {
      this.toasts.push(toast);
      this.cdr.detectChanges();
      setTimeout(() => {
        this.toasts.shift();
        this.cdr.detectChanges();
      }, 4000);
    });
  }

  get toastPosition() {
    switch (this.position) {
      case ToastPosition.BottomRight:
        return 'bottom-6 right-6 flex-col-reverse';
      case ToastPosition.TopRight:
        return 'top-6 right-6 flex-col';
      case ToastPosition.BottomLeft:
        return 'bottom-6 left-6 flex-col-reverse';
      case ToastPosition.TopLeft:
        return 'top-6 left-6 flex-col';
      default:
        return 'bottom-6 right-6 flex-col-reverse';
    }
  }
}
